
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/legal",
      function () {
        return require("private-next-pages/severalbrands/legal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands/legal"])
      });
    }
  